import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
//import { ErrorDialogService } from '../shared/error/errordialog.service';
//import { ErrorDialog } from '../shared/error/errordialog';
import { StorageService } from './storage.service';
import { environment } from 'src/environments/environment';


@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {

    urlApi: string = environment.apiRoot;

    /**
     * Creates an instance of TokenInterceptor.
     * @param {OidcSecurityService} storageService
     * @memberof TokenInterceptor
     */
    constructor(public storageService: StorageService) { }

    // constructor(public storageService: StorageService, public errorDialogService: ErrorDialogService) { }

    /**
     * Intercept all HTTP request to add JWT token to Headers
     * @param {HttpRequest<any>} request
     * @param {HttpHandler} next
     * @returns {Observable<HttpEvent<any>>}
     * @memberof TokenInterceptor
     */
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        //let modal = document.getElementById("loadingModalGlobal");
        //modal.style.display = "block";

        //setTimeout(() => { }, 100);

        //const date = Date.now();
        //let currentDate = null;
        //do {
        //    currentDate = Date.now();
        //} while (currentDate - date < 2000);

        request = request.clone({
            setHeaders: {
                Authorization: `Bearer ${this.storageService.get("token")}`,
                'Access-Control-Allow-Origin': '*'
            }
        });

        ///*----------------------------------------------------------------------------------------------------*/console.log("hrrp-config-interceptor.ts : intercept : request : ");
        ///*----------------------------------------------------------------------------------------------------*/console.log(request);
        ///*----------------------------------------------------------------------------------------------------*/console.log(request.headers.get("Authorization"));

        //console.log(this.storageService.get("token"));//.get("UserID"));

        ///*----------------------------------------------------------------------------------------------------*/if (this.storageService.get("CU") == "05310007") {
        //*----------------------------------------------------------------------------------------------------*/    console.log(request);
        ///*----------------------------------------------------------------------------------------------------*/}

        return next.handle(request).pipe(
            map((event: HttpEvent<any>) => {

                //let modal = document.getElementById("loadingModalGlobal");
                //modal.style.display = "none";

                if (event instanceof HttpResponse) {
                }
                return event;
            }),
            catchError((error: HttpErrorResponse) => {

                //console.log("catchError add bearer");
                //if (this.storageService.get("CU") == "05310007") {
                //    console.log(error);
                //}
                ///*----------------------------------------------------------------------------------------------------*/console.log("hrrp-config-interceptor.ts : intercept : catchError : ");
                ///*----------------------------------------------------------------------------------------------------*/console.log(error);

                switch (error.status) {
                    case 401:
                        ///*----------------------------------------------------------------------------------------------------*/console.log("http-config-interceptor.ts - error : 401")
                        // data = new ErrorDialog("Erreur d'authentification", error.status);

                        ///*----------------------------------------------------------------------------------------------------*/console.log(request.headers.get("Authorization"));

                        ///*----------------------------------------------------------------------------------------------------*/console.log("Authorization: `Bearer ${this.storageService.get('token')}`,")
                        ///*----------------------------------------------------------------------------------------------------*/console.log(request.headers);

                        console.log(error.url + " - 401 - Redirect to connexion portal");
                        //this.storageService.set("lastPage", window.document.location.href);
                        window.setTimeout(() => {
                            window.location.replace(this.urlApi + "/IxellApi/IdentificationLoginOAuth");
                        }, 50);
                        break;
                    case 0:
                    case 503:
                        if (request.url.toString().indexOf("logIn") == -1) {
                            // Cas auth
                            // data = new ErrorDialog(error && error.error.reason ? error.error.reason : '', error.status);
                        }
                        break;
                    case 504:
                        // data = new ErrorDialog("Pas de connexion", error.status);
                        break;
                    default:
                    // data = new ErrorDialog(error && error.error.reason ? error.error.reason : '', error.status);
                }
                // this.errorDialogService.warn(data);

                return throwError(error);
            })
        );

        
    }
}
